
import React from 'react';
import { ClubMessage } from './types';
import MessageBubble from './MessageBubble';
import { Loader2 } from 'lucide-react';

interface MessagesListProps {
  messages: ClubMessage[];
  currentUserId?: string;
  loading: boolean;
}

const MessagesList: React.FC<MessagesListProps> = ({ messages, currentUserId, loading }) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (messages.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="text-muted-foreground mb-2">No messages yet</div>
        <div className="text-sm text-muted-foreground">Start the conversation!</div>
      </div>
    );
  }

  return (
    <div className="space-y-4 py-4">
      {messages.map((message, index) => {
        const previousMessage = index > 0 ? messages[index - 1] : null;
        const showAuthor = !previousMessage || previousMessage.user_id !== message.user_id;
        
        return (
          <MessageBubble
            key={message.id}
            message={message}
            isOwn={message.user_id === currentUserId}
            showAuthor={showAuthor}
          />
        );
      })}
    </div>
  );
};

export default MessagesList;
